import { useNavigate } from 'react-router';

import { PaginatedTable } from '@app/components/paginated-table';
import { TableProps } from '@app/components/table';
import { ICategory } from '../types';
import { CategoryRow } from './category-row';
import { PATH_DASHBOARD } from '@app/routes/paths';

const PARENT_TABLE_HEAD = [
  { id: 'id', label: 'id', align: 'left', sortable: false },
  { id: 'image', label: 'Image', align: 'left', sortable: false },
  { id: 'category', label: 'Parent Category', align: 'center', sortable: false },
  { id: 'kind', label: 'Kind', align: 'center', sortable: false },
  { id: 'type', label: 'Type', align: 'center', sortable: false },
  { id: '', label: 'Top Category', align: 'center', sortable: false },
  { id: 'status', label: 'Status', align: 'center', sortable: false },
];

const CHILD_TABLE_HEAD = [
  { id: 'id', label: 'id', align: 'left', sortable: false },
  { id: 'image', label: 'Image', align: 'left', sortable: false },
  { id: 'category', label: 'Child Category', align: 'center', sortable: false },
  { id: 'parentCategory', label: 'Parent Category', align: 'center', sortable: false },
  { id: 'type', label: 'Type', align: 'center', sortable: false },
  { id: '', label: 'Top Category', align: 'center', sortable: false },
  { id: 'status', label: 'Status', align: 'center', sortable: false },
];

interface Props {
  tableProps: TableProps;
  rows?: ICategory[];
  loading: boolean;
  count?: number;
  page: number;
  kind?: 'parent' | 'child';
}

const CategoryList = ({ tableProps, rows, loading, count, page, kind = 'parent' }: Props) => {
  const navigation = useNavigate();
  const handleSelect = (data: any) => {
    const id = data.id;
    navigation(PATH_DASHBOARD.categoryDetail, { state: { id, page } });
  };

  return (
    <PaginatedTable<ICategory>
      head={kind === 'child' ? CHILD_TABLE_HEAD : PARENT_TABLE_HEAD}
      tableProps={tableProps}
      data={rows}
      loading={loading}
      isServerSidePaging={true}
      totalCount={count}
    >
      {(row) => (
        <CategoryRow
          row={row}
          kind={kind}
          selected={tableProps.selected.includes(row.id)}
          onSelectRow={() => {
            handleSelect(row);
          }}
        />
      )}
    </PaginatedTable>
  );
};
export default CategoryList;
